<div class="flex justify-between">
  <div class="text-xl text-gray-700 font-bold mb-4">Ordem de serviço</div>
</div>
<div>
  <mat-accordion>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title> Pesquisa </mat-panel-title>
      </mat-expansion-panel-header>
      <div>
        <form-search-os-proposal-client
          [search]="inputSearch"
          (responseSearch)="search($event)"
        />
      </div>
    </mat-expansion-panel>
  </mat-accordion>
  <div class="mt-4">
    <div>
      @if (!loading) {
        <div>
          <table-list-os
            [dataSource]="itemsList"
            [columns]="columns"
            (selectItem)="selectOsProposalClient($event)"
            (replierItem)="replierItem($event)"
            (deleteItem)="deleteItem($event)"
          />
<!--          <table-list-os-->
<!--            [dataSource]="itemsList"-->
<!--            [columns]="columns"-->
<!--            (selectItem)="editItem($event)"-->
<!--            (replierItem)="replierItem($event)"-->
<!--            (deleteItem)="deleteItem($event)"-->
<!--          />-->
          @if (itemsList.length > 0) {
            <mat-paginator
              [length]="numberRows"
              [pageSize]="rows"
              [pageIndex]="page - 1"
              [pageSizeOptions]="[5, 10, 20, 30]"
              (page)="onPageEvent($event)"
            >
            </mat-paginator>
          }
        </div>
      } @else {
        <div>
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      }
    </div>
  </div>
</div>
